const API_URL = import.meta.env['VITE_API_URL'];
import { load as groupLoad } from '@server/groupLoad';

export async function load({ params, parent, fetch, url }) {
  const groupData = await groupLoad({ params, parent, fetch });
  // Call Function 1 and get its results

  // Extract necessary variables from context

  let og = await fetch(
    `${API_URL}/api/groups/${params.username_or_id}|${params.slug}/rec_objects/${url.searchParams.get('detail_id')}/og`
  ).then((res) => res.json());

  // Merge and return combined result
  return {
    ...groupData,
    og,
    params: params,
    searchParams: url.searchParams,
  };
}
